import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModalsComponentsManager } from '@panneau/core/contexts';
import { useActionProps } from '@panneau/core/hooks';
import Button from '@panneau/element-button';

var styles = {};

var _excluded = ["id", "title", "description", "endpoint", "action", "label", "icon", "value", "theme", "disabled", "onClick", "onConfirmed", "valueLabelPath", "modalComponent", "withConfirmation", "className"];
var propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  endpoint: PropTypes.string,
  action: PropTypes.func,
  // Promise
  label: PropTypes.string,
  value: PropTypes.bool,
  icon: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onConfirmed: PropTypes.func,
  valueLabelPath: PropTypes.string,
  modalComponent: PropTypes.string,
  withConfirmation: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  title: null,
  description: null,
  endpoint: '/show',
  action: null,
  label: null,
  icon: 'eye',
  value: null,
  theme: 'infor',
  disabled: false,
  onClick: null,
  onConfirmed: null,
  valueLabelPath: null,
  modalComponent: 'dialog',
  withConfirmation: false,
  className: null
};
var ShowAction = function ShowAction(_ref) {
  var id = _ref.id,
    title = _ref.title;
    _ref.description;
    _ref.endpoint;
    _ref.action;
    var label = _ref.label,
    icon = _ref.icon,
    value = _ref.value,
    theme = _ref.theme,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
    _ref.onConfirmed;
    var valueLabelPath = _ref.valueLabelPath,
    modalComponent = _ref.modalComponent,
    withConfirmation = _ref.withConfirmation,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ModalComponents = useModalsComponentsManager();
  var ModalComponent = ModalComponents.getComponent(modalComponent);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useActionProps = useActionProps(id, value, valueLabelPath),
    modalKey = _useActionProps.modalKey;
  var onOpen = useCallback(function () {
    setModalOpen(true);
  }, [setModalOpen]);
  var onClose = useCallback(function () {
    setModalOpen(false);
  }, [setModalOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    label: label,
    icon: icon,
    onClick: withConfirmation ? onOpen : onClick,
    disabled: disabled,
    theme: disabled ? 'secondary' : theme
  }, props)), modalOpen ? /*#__PURE__*/React.createElement(ModalComponent, {
    id: modalKey,
    title: title || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "BIYKx5",
      defaultMessage: [{
        "type": 0,
        "value": "Preview"
      }]
    }),
    onClose: onClose,
    confirmButton: {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "UaVu03",
        defaultMessage: [{
          "type": 0,
          "value": "Confirm"
        }]
      }),
      theme: 'danger'
    },
    cancelButton: {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "PyxZY2",
        defaultMessage: [{
          "type": 0,
          "value": "Cancel"
        }]
      })
    }
  }, "Show Something") : null);
};
ShowAction.propTypes = propTypes;
ShowAction.defaultProps = defaultProps;

export { ShowAction as default };
